import { useState, useCallback, useEffect } from 'react';

function useToggleMenu() {
  const [y, useSetY] = useState(window.scrollY);
  const [scrolly, useSetScrollY] = useState(false);
  // by default the scrool will always be active.
  document.body.style.overflow = 'auto';
  // function so that the body does not scroll
  const handleChangeToggle = (toggle) => {
    if (toggle) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
  };

  const handleNavigation = useCallback(
    (e) => {
      const window = e.currentTarget;
      if (window.scrollY > 3) {
        useSetScrollY(true);
      } else {
        useSetScrollY(false);
      }
      useSetY(window.scrollY);
    },
    [y]
  );

  useEffect(() => {
    useSetY(window.scrollY);
    window.addEventListener('scroll', handleNavigation);
    return () => {
      window.removeEventListener('scroll', handleNavigation);
    };
  }, [handleNavigation]);

  return {
    scrolly,
    handleChangeToggle,
  };
}

export default useToggleMenu;
